<template>
  <div :class="{ 'pa-2': padding }">
    <div class="text-h6 font-weight-bold">
      Compra fiado con todos nuestros proveedores
    </div>
    <div class="slider mb-4" @click="$router.push({ name: 'where-buy' })">
      <div class="slide-track">
        <div
          class="slide"
          v-for="supplier in suppliers"
          :key="supplier"
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: 3em;
            margin-right: 3em;
          "
        >
          <img :src="supplier" height="" width="90" alt="" />
        </div>
        <div
          class="slide"
          v-for="supplier in suppliers"
          :key="supplier"
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: 3em;
            margin-right: 3em;
          "
        >
          <img :src="supplier" width="90" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["padding"],

  data() {
    return {
      suppliers: [
        "https://assets.mangxo.com/proveedores/logos/gama.png",
        "https://assets.mangxo.com/proveedores/logos/proveedora-de-plafones-y-acabados.png",
        "https://assets.mangxo.com/proveedores/logos/regio-mecasa.png",
        "https://assets.mangxo.com/proveedores/logos/aceros-escobedo.png",
        "https://assets.mangxo.com/proveedores/logos/smart-blocks.png",
        "https://assets.mangxo.com/proveedores/logos/mat-movil.png",
        "https://assets.mangxo.com/proveedores/logos/concremovil.png",
        "https://assets.mangxo.com/proveedores/logos/tumatsa.png",
        "https://assets.mangxo.com/proveedores/logos/surtidor-electrico.png",
        "https://assets.mangxo.com/proveedores/logos/mado.png",
        "https://assets.mangxo.com/proveedores/logos/getsa.png",
      ],
    };
  },

  methods: {},
};
</script>

<style>

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-250px * 11));
  }
}

.slider {
  background: white;
  box-shadow: 0 10px 20px -5px rgba(0, 0, 0, 0.05);
  margin: auto;
  overflow: hidden;
  position: relative;

  &::before,
  &::after {
    @include white-gradient;
    content: "";
    height: 100px;
    position: absolute;
    width: 200px;
    z-index: 2;
  }

  &::after {
    right: 0;
    top: 0;
    transform: rotateZ(180deg);
  }

  &::before {
    left: 0;
    top: 0;
  }

  .slide-track {
    animation: scroll 20s linear infinite;
    display: flex;
    width: calc(250px * 22);
  }

  .slide {
    height: 100px;
    width: 250px;
  }
}
</style>
